var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 52,
    viewBox: "0 0 30 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52513 28.4749C0.158291 27.108 0.158291 24.892 1.52513 23.5251L23.799 1.25126C25.1658 -0.115572 27.3819 -0.115572 28.7487 1.25126C30.1156 2.6181 30.1156 4.83418 28.7487 6.20101L8.94975 26L28.7487 45.799C30.1156 47.1658 30.1156 49.3819 28.7487 50.7487C27.3819 52.1156 25.1658 52.1156 23.799 50.7487L1.52513 28.4749ZM6.5 29.5H4V22.5H6.5V29.5Z",
    fill: "#A3A3A3",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.9339ef1b808a3e0a2841903f3141e041.svg";
export { ForwardRef as ReactComponent };